import "./ExpenseInfoFieldsPanelStyle.css"
import { Box, Typography } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	FieldLayout,
	LabelPosition,
} from "@websential/cosmic-v20";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FC, JSX, useEffect, useState } from "react";
import Select, { GroupBase, OptionProps, components } from 'react-select'

export interface MenuOption {
	label: string;
	value: string;
	slug: string;
	parentId?: string;
}
export const convertMenuHeadTreeDDLData = (data: any[]) => {
	const result: any[] = [];

	data.forEach((item) => {
		const { options, ...parent } = item;

		// push parent without options
		result.push(parent);

		// if options exist, push them with 
		if (options && options.length > 0) {
			options.forEach((child: any) => {
				result.push({
					...child,
					parentId: item.value,
				});
			});
		}
	});

	// result.unshift({
	// 	label: "--",
	// 	value: null,
	// });

	return result;
};
interface IExpenseInfoFieldsPanel {
	accountSettingsDDL: any;
	formMethods: any;
	addedEmployeesprovince: any;
	accountDDL: any;
	classDDl: any;
	departmentDDL: any;
	linkEmployeesUpdatedData: any;
	onLinkEmployeesDataChange: (data: any[]) => void;
	accountSettingsPageName: string;
}
export const ExpenseInfoFieldsPanel: FC<
	IExpenseInfoFieldsPanel
> = ({ accountSettingsDDL, formMethods, addedEmployeesprovince,
	accountDDL,
	classDDl,
	departmentDDL,
	linkEmployeesUpdatedData,
	onLinkEmployeesDataChange,
	accountSettingsPageName,

}) => {
		const [menuHeadDDL, setMenuHeadDDL] = useState<MenuOption[]>([]);

		useEffect(() => {
			if (accountSettingsDDL) {
				const ddl = convertMenuHeadTreeDDLData(accountSettingsDDL)
				setMenuHeadDDL(ddl)
			}
		}, [accountSettingsDDL])


		const columns = [
			{ field: "accountId", headerName: "Account" },
			{ field: "class", headerName: "Class" },
			{ field: "department", headerName: "Department" },
		];

		const [listItems, setListItems] = useState(linkEmployeesUpdatedData);

		const onCellValueChange = (event: any, rowIndex: number, field: any) => {
			setListItems((prev: any) => {
				const updatedData = [...prev];
				const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
				updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
				return updatedData;
			});
		};

		const columnsBody = (rowData: any, row: any, x: any) => {
			if (x.field === "accountId") {
				return (
					<Dropdown
						options={accountDDL ?? []}
						value={rowData.accountId}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.value)
						}
						optionLabel="label"
						optionValue="value"
						style={{ borderRadius: "2px", fontSize: "0.875rem" }}
					/>
				);
			}
			if (x.field === "class") {
				return (
					<Dropdown
						options={classDDl ?? []}
						value={rowData.class}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.value)
						}
						optionLabel="label"
						optionValue="value"
						style={{ borderRadius: "2px", fontSize: "0.875rem" }}
					/>
				);
			}
			if (x.field === "department") {
				return (
					<Dropdown
						options={departmentDDL ?? []}
						value={rowData.department}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.value)
						}
						optionLabel="label"
						optionValue="value"
						style={{ borderRadius: "2px", fontSize: "0.875rem" }}
					/>
				);
			}
		};


		return (
			<>
				<DataTable
					value={listItems}
					// dataKey="id"
					showGridlines
					className="AccountSettingsExpenseFieldsStyle"
					columnResizeMode="expand"
					scrollable
					filterDisplay="menu"
					scrollHeight="416px"
				>
					{columns.map((x: any) => (
						<Column
							key={x.field}
							field={x.field}
							header={x.headerName}
							columnKey={x.field}
							style={{
								fontSize: "0.875rem",
							}}
							body={(rowData, row) =>
								columnsBody(rowData, row, x)
							}
						/>
					))}
				</DataTable>
				<EnhancedDropDownRHFWithLabel
					label="Gross Amount"
					selectName="grossAmount"
					testId="gross-amount"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>
				{/* <FieldLayout
				label="Gross Amount"
				testId="gross-amount"
			>
				<Select
					id="grossAmount"
					{...formMethods.register("grossAmount")}
					// value={formMethods.watch("menuParentId")?.value || undefined}
					value={getSingleSelectValue(menuHeadDDL)}
					onChange={onHeadSelectionChangeHandler}
					options={getItems(menuHeadDDL)}
					styles={customStyles}
					hideSelectedOptions={false}
					components={{
						Option,
						IndicatorSeparator: () => null,
					}}
				/>
			</FieldLayout> */}

				<EnhancedDropDownRHFWithLabel
					label="Overtime"
					selectName="overtime"
					testId="overtime"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="Vacation Pay"
					selectName="vacationPay"
					testId="vacation-pay"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="Commission"
					selectName="commission"
					testId="commission"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="Npp/Bonus"
					selectName="nppBonus"
					testId="npp-bonus"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="Holiday Pay"
					selectName="holidayPay"
					testId="holiday-pay"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="CPP - Company"
					selectName="cppCompany"
					testId="cpp-company"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				<EnhancedDropDownRHFWithLabel
					label="EI - Company"
					selectName="eiCompany"
					testId="ei-company"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>

				{addedEmployeesprovince?.provincesForTDForm?.QC &&
					<><EnhancedDropDownRHFWithLabel
						label="QPP - Company"
						selectName="qppCompany"
						testId="qpp-company"
						labelPosition={LabelPosition.Top}
						items={accountSettingsDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						showEmpty
					/>

						<EnhancedDropDownRHFWithLabel
							label="QPIP - Company"
							selectName="qpipCompany"
							testId="qpip-company"
							labelPosition={LabelPosition.Top}
							items={accountSettingsDDL ?? []}
							labelColumns={4}
							fieldColumns={8}
							showEmpty
						/>

						<EnhancedDropDownRHFWithLabel
							label="QHSF - Company"
							selectName="qhsfCompany"
							testId="qhsf-company"
							labelPosition={LabelPosition.Top}
							items={accountSettingsDDL ?? []}
							labelColumns={4}
							fieldColumns={8}
							showEmpty
						/>

						<EnhancedDropDownRHFWithLabel
							label="CSST - Company"
							selectName="csstCompany"
							testId="csst-company"
							labelPosition={LabelPosition.Top}
							items={accountSettingsDDL ?? []}
							labelColumns={4}
							fieldColumns={8}
							showEmpty
						/></>}

				<EnhancedDropDownRHFWithLabel
					label="WSIB"
					selectName="wsib"
					testId="wsib"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>
			</>
		);
	};

// const customStyles = {
// 	control: (provided: any, state: { isDisabled: any; }) => {
// 		return ({
// 			...provided,
// 			backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.06)' : '#fff',
// 			borderColor: '#c3c4c4',
// 			minHeight: '3em',
// 			borderRadius: "2px !important",
// 			marginBottom: "35px",
// 			// height: '3em',
// 			// boxShadow: state.isFocused ? null : null,
// 			":hover": {
// 				borderColor: '#000'
// 			},
// 		})
// 	},
// 	container: (provided: any) => ({
// 		...provided,
// 		fontFamily: ["Roboto", "sans-serif"].join(","),
// 		fontSize: ".8125rem",
// 		fontWeight: 500,
// 		lineHeight: "1rem",
// 	}),
// };

// const getItems = (options: any[]) => {
// 	return options.map((item, index) => ({
// 		...item,
// 		value: item.value,
// 		label: item.label,
// 	}));
// };

// const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {

// 	return (
// 		<div>
// 			<components.Option {...props}>
// 				<label style={{ fontWeight: !props.data.parentId ? "bold" : "normal", marginLeft: props.data.parentId ? "1.5rem" : 0 }}>{props.label}</label>
// 			</components.Option>
// 		</div>
// 	);
// };

// const onHeadSelectionChangeHandler = (selected: any) => {
// 	formMethods.setValue("grossAmount", selected.value);
// };

// const selectedValue = formMethods.watch("grossAmount");

// const getSingleSelectValue = (options: any[]) => {
// 	if (!selectedValue) return null;

// 	return options.find((option) => {
// 		return option && option.value === selectedValue;
// 	});
// };